const { getDate } = require('./getDate')
const { getTime } = require('./getTime')

/**
 * Visszaadja a teljes dátumot a paramétereknek megfelelően.
 * @param {string | number} [param] - Az idő számként vagy stringként, ebből generáljuk a kimenetet.
 * @returns {string} A teljes dátum, stringként.
 */
module.exports.getFullDate = function getFullDate (param) {
  const date = getDate(param)
  const time = getTime(param)

  return `${ date } ${ time }`
}
